// extracted by mini-css-extract-plugin
export var card = "_8z-0";
export var failedIcon = "_8z-4";
export var failedIconBadge = "_8z-3";
export var icon = "_8z-1";
export var successIcon = "_8z-2";